import React from "react";
import { Outlet } from "react-router";
import { PageShell } from "@sscs/ui";
import Navigation from "./Navigation";

// Layout for the organization Administration pages: it owns the shared
// left-hand navigation rail while each destination renders its own content
// (page title, tabs, tables) into the shell's content area via <Outlet />.
const Administration = (): React.JSX.Element => {
  return (
    <PageShell sidebar={<Navigation />}>
      <Outlet />
    </PageShell>
  );
};

export default Administration;
